import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlookMailLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Outlook icon 1",
		clipPath: "url(#clip0_2763_43605)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M13.8016 0.958984H5.5598C5.38129 0.958984 5.21009 1.02988 5.08386 1.15607C4.95763 1.28225 4.88672 1.4534 4.88672 1.63186V2.39676L9.5321 3.83453L14.4747 2.39676V1.63186C14.4747 1.4534 14.4038 1.28225 14.2776 1.15607C14.1514 1.02988 13.9802 0.958984 13.8016 0.958984Z",
				fill: "#0364B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M15.2655 8.34138C15.3358 8.12073 15.3918 7.89581 15.4333 7.66802C15.4333 7.61205 15.4185 7.55709 15.3905 7.50864C15.3624 7.46018 15.3222 7.41995 15.2737 7.39197L15.2675 7.38813L15.2655 7.38717L10.0698 4.42824C10.0474 4.4137 10.0242 4.40042 10.0003 4.38846C9.90092 4.33914 9.79148 4.31348 9.68053 4.31348C9.56959 4.31348 9.46015 4.33914 9.36077 4.38846C9.33689 4.40025 9.31368 4.41337 9.29126 4.42776L4.09552 7.38765L4.09361 7.38861L4.08785 7.39197C4.03928 7.41989 3.99892 7.4601 3.97081 7.50855C3.9427 7.55701 3.92785 7.61201 3.92773 7.66802C3.96926 7.89581 4.02531 8.12072 4.09552 8.34138L9.60479 12.3695L15.2655 8.34138Z",
				fill: "#0A2767"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M11.5981 2.39648H8.2423L7.27344 3.83426L8.2423 5.27203L11.5981 8.14758H14.4745V5.27203L11.5981 2.39648Z",
				fill: "#28A8EA"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M4.88477 2.39648H8.24057V5.27203H4.88477V2.39648Z",
				fill: "#0078D4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M11.5977 2.39648H14.4741V5.27203H11.5977V2.39648Z",
				fill: "#50D9FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M11.5983 8.14703L8.24252 5.27148H4.88672V8.14703L8.24252 11.0226L13.4354 11.8699L11.5983 8.14703Z",
				fill: "#0364B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M8.24219 5.27148H11.598V8.14703H8.24219V5.27148Z",
				fill: "#0078D4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_8",
				d: "M4.88477 8.14746H8.24057V11.023H4.88477V8.14746Z",
				fill: "#064A8C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_9",
				d: "M11.5977 8.14746H14.4741V11.023H11.5977V8.14746Z",
				fill: "#0078D4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_10",
				opacity: .5,
				d: "M9.77075 12.0862L4.11719 7.96453L4.35449 7.54758C4.35449 7.54758 9.50564 10.4806 9.58427 10.5247C9.61643 10.5376 9.6509 10.5437 9.68554 10.5427C9.72017 10.5417 9.75423 10.5337 9.78561 10.519L15.0269 7.5332L15.2647 7.94968L9.77075 12.0862Z",
				fill: "#0A2767"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_11",
				d: "M15.273 7.9445L15.2662 7.94833L15.2648 7.94929L10.0691 10.9082C9.96587 10.9747 9.84734 11.0137 9.72479 11.0213C9.60225 11.029 9.47979 11.005 9.36914 10.9518L11.1784 13.3774L15.1354 14.2386V14.2405C15.2274 14.1739 15.3023 14.0865 15.354 13.9854C15.4057 13.8842 15.4326 13.7723 15.4326 13.6587V7.66797C15.4326 7.72402 15.4179 7.77908 15.3898 7.82762C15.3618 7.87617 15.3215 7.91648 15.273 7.9445Z",
				fill: "#1490DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_12",
				opacity: .05,
				d: "M15.4326 13.6588V13.3051L10.6467 10.5791L10.0691 10.9084C9.96587 10.9749 9.84734 11.0138 9.72479 11.0214C9.60225 11.0291 9.47979 11.0052 9.36914 10.952L11.1784 13.3775L15.1354 14.2387V14.2406C15.2274 14.1741 15.3023 14.0866 15.354 13.9855C15.4057 13.8843 15.4326 13.7724 15.4326 13.6588Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_13",
				opacity: .1,
				d: "M15.4086 13.8427L10.1625 10.8555L10.0691 10.9082C9.96592 10.9748 9.8474 11.0138 9.72486 11.0215C9.60231 11.0292 9.47983 11.0054 9.36914 10.9523L11.1784 13.3778L15.1354 14.239V14.2409C15.2695 14.1438 15.3661 14.0033 15.4086 13.8432V13.8427Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_14",
				d: "M4.09554 7.95073V7.94594H4.09074L4.07636 7.93635C4.03053 7.90824 3.99276 7.86875 3.96672 7.82172C3.94068 7.77469 3.92725 7.72172 3.92775 7.66797V13.6587C3.92762 13.7531 3.94614 13.8467 3.98223 13.9339C4.01832 14.0212 4.07129 14.1005 4.13809 14.1673C4.20489 14.2341 4.28421 14.287 4.37151 14.3231C4.45881 14.3592 4.55238 14.3777 4.64685 14.3776H14.7142C14.7741 14.377 14.8337 14.3689 14.8916 14.3536C14.9217 14.3484 14.9508 14.3387 14.9779 14.3249C14.9881 14.3239 14.9979 14.3206 15.0067 14.3153C15.0459 14.2992 15.083 14.2783 15.1169 14.253C15.1265 14.2482 15.1313 14.2482 15.1361 14.2386L4.09554 7.95073Z",
				fill: "#28A8EA"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_15",
				opacity: .1,
				d: "M8.71978 11.8215V3.99334C8.71928 3.82406 8.65179 3.66186 8.53205 3.54217C8.41232 3.42247 8.25007 3.355 8.08074 3.35449H4.89896V6.92784L4.09357 7.38697L4.09117 7.38792L4.08542 7.39128C4.03687 7.4193 3.99655 7.45961 3.96853 7.50816C3.94051 7.5567 3.92576 7.61176 3.92578 7.66781V12.4604H8.08074C8.25007 12.4599 8.41232 12.3924 8.53205 12.2727C8.65179 12.153 8.71928 11.9908 8.71978 11.8215Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_16",
				opacity: .2,
				d: "M8.24233 12.301V4.47283C8.24183 4.30356 8.17434 4.14136 8.05461 4.02166C7.93487 3.90196 7.77262 3.83449 7.60329 3.83398H4.90092V6.92807L4.09552 7.3872L4.09313 7.38816L4.08737 7.39151C4.03882 7.41954 3.99851 7.45985 3.97048 7.50839C3.94246 7.55693 3.92772 7.612 3.92773 7.66805V12.9399H7.60329C7.77262 12.9394 7.93487 12.8719 8.05461 12.7522C8.17434 12.6325 8.24183 12.4703 8.24233 12.301Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_17",
				opacity: .2,
				d: "M8.24233 11.3425V4.47283C8.24183 4.30356 8.17434 4.14136 8.05461 4.02166C7.93487 3.90196 7.77262 3.83449 7.60329 3.83398H4.90092V6.92807L4.09552 7.3872L4.09313 7.38816L4.08737 7.39151C4.03882 7.41954 3.99851 7.45985 3.97048 7.50839C3.94246 7.55693 3.92772 7.612 3.92773 7.66805V11.9814H7.60329C7.77262 11.9809 7.93487 11.9134 8.05461 11.7937C8.17434 11.674 8.24183 11.5118 8.24233 11.3425Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_18",
				opacity: .2,
				d: "M7.76293 11.3425V4.47283C7.76243 4.30356 7.69494 4.14136 7.57521 4.02166C7.45547 3.90196 7.29322 3.83449 7.12389 3.83398H4.90092V6.92807L4.09552 7.3872L4.09313 7.38816L4.08737 7.39151C4.03882 7.41954 3.99851 7.45985 3.97048 7.50839C3.94246 7.55693 3.92772 7.612 3.92773 7.66805V11.9814H7.12389C7.29322 11.9809 7.45547 11.9134 7.57521 11.7937C7.69494 11.674 7.76243 11.5118 7.76293 11.3425Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_19",
				d: "M0.730837 3.83398H7.12316C7.29264 3.83398 7.45518 3.90129 7.57503 4.0211C7.69487 4.14091 7.7622 4.3034 7.7622 4.47283V10.8633C7.7622 11.0327 7.69487 11.1952 7.57503 11.315C7.45518 11.4348 7.29264 11.5021 7.12316 11.5021H0.730837C0.561353 11.5021 0.398811 11.4348 0.278967 11.315C0.159124 11.1952 0.0917969 11.0327 0.0917969 10.8633L0.0917969 4.47283C0.0917969 4.3034 0.159124 4.14091 0.278967 4.0211C0.398811 3.90129 0.561353 3.83398 0.730837 3.83398Z",
				fill: "#0078D4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_20",
				d: "M1.94525 6.45431C2.11505 6.09253 2.38918 5.78977 2.73242 5.58493C3.11269 5.36731 3.54567 5.25885 3.98366 5.2715C4.38921 5.26271 4.78937 5.36549 5.14045 5.56864C5.47092 5.76543 5.73707 6.05398 5.90653 6.39919C6.09113 6.77971 6.18312 7.19847 6.17499 7.6213C6.18387 8.06295 6.08914 8.50054 5.89838 8.899C5.72524 9.2565 5.45106 9.55543 5.10977 9.75879C4.74492 9.96841 4.32956 10.074 3.90887 10.0641C3.49442 10.0739 3.0852 9.97001 2.72571 9.76358C2.3926 9.56647 2.12331 9.27763 1.95004 8.93159C1.76417 8.55669 1.67096 8.1427 1.67822 7.72434C1.67018 7.28627 1.76148 6.85207 1.94525 6.45431ZM2.7842 8.49499C2.87466 8.72369 3.02808 8.9221 3.22668 9.06722C3.42907 9.20883 3.67151 9.28189 3.91846 9.2757C4.18153 9.28593 4.44081 9.2104 4.65721 9.06051C4.85361 8.91547 5.00312 8.716 5.08724 8.48684C5.18155 8.23152 5.22802 7.96102 5.22434 7.68888C5.22727 7.41415 5.1835 7.14092 5.09491 6.88085C5.01673 6.64688 4.87256 6.4405 4.67975 6.28657C4.46905 6.12914 4.21053 6.04908 3.9477 6.05988C3.69538 6.0535 3.44751 6.12715 3.23963 6.27027C3.03712 6.41565 2.88016 6.61561 2.78707 6.84682C2.58115 7.37687 2.57996 7.96458 2.78372 8.49547L2.7842 8.49499Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2763_43605",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 15.3362,
			fill: "white"
		})
	}) })]
});
export { SvgOutlookMailLogo as ReactComponent };
